import {
    Card,
    CardHeader,
    CardContent,
    Avatar,
    IconButton,
    Divider,
    List,
    ListItem,
    ListItemButton,
    ListItemIcon,
    ListItemText,
} from "@mui/material";
import { Logout, SettingsOutlined, AccountBox } from "@mui/icons-material";
import { useNavigate } from "react-router-dom";
import useAuth from "../hooks/useAuth";
import useAxiosPrivate from "../hooks/useAxiosPrivate";

import React from "react";

const PopperProfile = () => {
    const navigate = useNavigate();
    const axiosPrivate = useAxiosPrivate();
    const { setAuth } = useAuth();

    const handleLogout = async () => {
        setAuth({});
        await axiosPrivate.get("/auth/logout");
        navigate("/");
    };

    return (
        <div>
            <Card elevation={5} sx={{ width: "300px" }}>
                <CardHeader
                    avatar={<Avatar src="/img/profile.jpg">JT</Avatar>}
                    action={
                        <IconButton onClick={handleLogout}>
                            <Logout />
                        </IconButton>
                    }
                    title="Jonathan Tang"
                />
                <CardContent>
                    <Divider />
                    <List dense>
                        <ListItem disablePadding>
                            <ListItemButton>
                                <ListItemIcon>
                                    <AccountBox />
                                </ListItemIcon>
                                <ListItemText primary="View Profile" />
                            </ListItemButton>
                        </ListItem>
                        <ListItem disablePadding>
                            <ListItemButton>
                                <ListItemIcon>
                                    <SettingsOutlined />
                                </ListItemIcon>
                                <ListItemText primary="Settings" />
                            </ListItemButton>
                        </ListItem>
                    </List>
                </CardContent>
            </Card>
        </div>
    );
};

export default PopperProfile;
